<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    item-value="id"
    item-text="name"
    label="Хелперы"
    prepend-inner-icon="mdi mdi-reload mdi-18px"
    :rules="rule"
    multiple
    @click:prepend-inner="refresh"
  >
    <!-- Чипсы в инпуте -->
    <template #selection></template>
    <template #append>
      <span v-if="selected.length === 1" class="mr-2 mt-n1" style="max-width: 130px;">
        <v-chip small >
          <span class="sliced-name">{{ items.find(v => v.id === selected[0]).name }}</span>
        </v-chip>
      </span>

      <span v-else-if="selected.length > 1" class="mt-n1">
        <v-chip small style="max-width: 130px;">
          <span class="sliced-name">{{ items.find(v => v.id === selected[0]).name }}</span>
        </v-chip>
        <span class="grey--text caption">(+{{selected.length - 1}})</span>
      </span>
    </template>

    <!-- Убираем чекбоксы в меню -->
    <template #item="data">
      <template>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.name"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>

    <!-- Строка "Выбрать всё" -->
    <template #prepend-item>
      <v-list-item ripple @click="toggleAll">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{toggleAllText}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  
  </v-autocomplete>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'HelperSelector',
  props: {
    value: {
      required: true,
    },
    noRules: Boolean,
  },

  data() {
    return {
      items: [],
      rule: [
        v => {
          if (this.noRules) return true
          else {
            return !!v.length || 'Данное поле обязательно'
          }
        }
      ],
    }
  },

  computed: {
    ...mapGetters({}),

    selected: {
      get() {
        return this.value;
      },
      set(selected) {
        // Выдёргиваю все ID форм связанных с выбранными хелперами
        const formsIds = this.items.filter(item => selected.includes(item.id))
          .flatMap(item => item.forms.map(f => f.id))
        const queuesIds = this.items.filter(item => selected.includes(item.id))
          .flatMap(item => item.queues.map(f => f.id))

        this.$emit('change:queues', queuesIds);
        this.$emit('change:forms', formsIds);
        this.$emit('input', selected);
      },
    },

    allItems() {
      return this.selected.length === this.items.length
    },

    moreItems() {
      return this.selected.length !== 0 && this.selected.length < this.items.length
    },

    icon() {
      if (this.allItems) return "mdi-close-box";
      if (this.moreItems) return "mdi-plus-box";
      return "mdi-checkbox-blank-outline";
    },

    toggleAllText() {
      if (this.allItems) return "Отменить все";
      if (this.moreItems) return "Выбрать все";
      return "Выбрать все";
    },
  },

  watch: {},

  methods: {
    ...mapActions({
      loadGraph: 'graphql/loadGraph',
    }),

    refresh() {
      this.selected = [];
    },

    toggleAll() {
      this.$nextTick(() => {
        if (this.allItems) {
          this.selected = [];
        } else {
          this.selected = this.items.map(v => v.id);
        }
      });
    },
  },

  async mounted() {
    let q = `helpers {
      data {
        id
        name
        forms {
          id
        }
        queues {
          id
        }
      }
    }`

    let res = await this.loadGraph(q)

    this.items = res.helpers.data
  },
}
</script>

<style scoped lang="scss">
.sliced-name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>